<template>
  <div id="list-demo">
    <div class="ml-4">
        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Cancel
        </button>
        <button v-on:click="savelistview" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Save
        </button>


        <button v-on:click="saveDeploylistview" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
            Save and Deploy
        </button>

    </div>  
    <div class="widget-container">

      <div class="bg-gray-50 border-gray-300 mr-4">  
          <span class="list-title">Available fields</span>
      <DxList
        :data-source="list2"
        :repaint-changes-only="true" 
        key-expr="name"
        display-expr="label.text"
        >
        
        <DxItemDragging
          data="list2"          
          :allow-reordering="true"
          :on-drag-start="onDragStart"
          :on-add="onAdd"
          :on-remove="onRemove"
          group="tasks"
        />     
        
      </DxList>
      </div>
      <div class="bg-gray-50 ">
          <span class="list-title">List View</span>
      <DxList
        :data-source="list1"
        :repaint-changes-only="true"
        key-expr="name"
        display-expr="label.text"
      >
        <DxItemDragging
          data="list1"
          :allow-reordering="true"
          :on-drag-start="onDragStart"
          :on-add="onAdd"
          :on-remove="onRemove"
          group="tasks"
        />
      </DxList>
      </div>
        
    </div>
    
  </div>
</template>

<script>

import DxList, { DxItemDragging } from 'devextreme-vue/list';

import {getFieldsList,getLayout,setDeployLayout,setLayout} from '../../base.js';

export default {
    props:{
        modulekey:String,
        studio:Boolean,
        route_slug:String
    },
    components: {
        DxList,
        DxItemDragging,
    },
    data() {
            return {
                fieldList:[],
                list1: [],
                list2: []
                };
        },
    methods:{
                        
            savelistview()
            {
                let model=JSON.stringify(this.list1, null, 2);
                let avlField = JSON.stringify(this.list2, null, 2);
                this.errors = {};    
             
                setLayout(this.modulekey,"listview",this.studio,model,this.route_slug).then(response => {
                    //console.log('get'+JSON.stringify(response.data));
                }).catch(error => {
                    if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    }
                });
            },

            saveDeploylistview()
            {
                let model=JSON.stringify(this.list1, null, 2);  console.log("save data",model); console.log("list2",this.list2);
                this.errors = {};    
                
                setDeployLayout(this.modulekey,"listview",this.studio,model,this.route_slug).then(response => {
                    //console.log('get'+JSON.stringify(response.data));
                }).catch(error => {
                    if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    }
                });
            },




            onDragStart(e) {
                e.itemData = this[e.fromData][e.fromIndex];
            },
            onAdd(e) {
                const data = [...this[e.toData]];
                data.splice(e.toIndex, 0, e.itemData);
                this[e.toData] = data;
            },
            onRemove(e) {
                const data = [...this[e.fromData]];
                data.splice(e.fromIndex, 1);
                this[e.fromData] = data;
            }    
        },
        created: function () { 
            this.errors = {};                     
            getFieldsList(this.modulekey,this.studio,false,this.route_slug).then(response => {

                this.list2 = Object.values(response.data);
                this.fieldList = Object.values(response.data);
                //console.log(this.list2);                  
            }).catch(error => {
                //console.log(error);
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });
            //get the editview layout
            getLayout(this.modulekey,"listview",this.studio,this.route_slug).then(response => {
                
                this.list1 = response.data;
                this.list2 = this.list2.filter(item => !this.list1.find(field => item.dataField === field.dataField));
                this.list1 = this.list1.filter(item => this.fieldList.find(field => item.dataField === field.dataField));

            }).catch(error => {
                if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
                }
            });

            
        },
        mounted()
        {
            console.log("LIST VIEW LAYOUT",this.route_slug);
        }
}
</script>

<style>
.widget-container {
    display: flex;
    width: 50%;
    margin: 20px;
}

.widget-container > * {
    height: 400px;
    width: 50%;
    padding: 10px;
}

.dx-scrollview-content {
    min-height: 380px;
}
.list-title {
    font-size: 16px;
    padding: 10px;
    padding-left: 30px;   
    font-weight: bold;
    cursor: pointer;
}

</style>